<template>
    <div>
        <!-- 大播放 --->
        <div class="library-player library-player--expanded" v-if="track && isOpen">
            <ProgressBar class="library-player__progress" />
            <div class="library-player__grid">
                <!-- Track info --->
                <div class="library-player__track">
                    <div class="library-player__track-inner">
                        <button type="button" @click="handlePlayingDetails" class="library-player__cover" aria-label="打开正在播放详情">
                            <img v-if="track.image" :src="track.image"
                                 class="library-player__cover-image">
                            <img v-else src="/static/dist/img/album_null.jpg" class="library-player__cover-image">
                        </button>
                        <div class="library-player__meta">
                            <router-link :to="{ name: 'album', params: { id: track.albumId } }" class="library-player__title-link">
                                <div class="library-player__title">
                                    {{ streamTitle || track.title }}
                                </div>
                            </router-link>
                            <router-link :to="{ name: 'artist', params: { id: track.artistId } }" class="library-player__artist-link">
                                <div class="library-player__artist">
                                    {{ track.artist || track.album }}
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>

                <!-- Controls--->
                <div class="library-player__controls">
                    <button type="button" class="library-player__icon-button d-none d-sm-inline-block" :class="syncReadonly ? 'is-disabled' : ''" :disabled="syncReadonly" @click="previous" aria-label="上一首">
                        <svg-icon name="player-previous" class="fill-current"></svg-icon>
                    </button>
                    <button type="button" class="library-player__play-toggle" :class="syncReadonly ? 'is-disabled' : ''" :disabled="syncReadonly" @click="playPause" aria-label="播放或暂停">
                        <svg-icon v-if="!isPlaying" name="player-play" class="fill-current" width="100%" height="100%"></svg-icon>
                        <svg-icon v-else name="player-pause" class="fill-current" width="100%" height="100%"></svg-icon>
                    </button>
                    <button type="button" class="library-player__icon-button" :class="syncReadonly ? 'is-disabled' : ''" :disabled="syncReadonly" @click="next" aria-label="下一首">
                        <svg-icon name="player-next" class="fill-current"></svg-icon>
                    </button>
                </div>
                <!-- Controls right --->
                <!-- 音量 --->
                <div class="library-player__actions">
                    <!-- 播放队列 --->
                    <button type="button" class="library-player__icon-button d-none d-sm-inline-block md:!hidden" @click="openModal" aria-label="播放队列">
                        <svg-icon name="playlist" class="icon fill-current"></svg-icon>
                    </button>
                    <div class="library-player__dropdown !hidden md:!flex" ref="volumeDropdown" @keydown.esc="closeVolumeMenu">
                        <button type="button" class="library-player__icon-button" :class="isVolumeOpen ? 'is-active' : ''" :aria-expanded="isVolumeOpen ? 'true' : 'false'" aria-label="音量" @click.stop="toggleVolumeMenu">
                            <svg-icon name="player-volume" class="icon fill-current" :viewBox="'0 0 24 24'"></svg-icon>
                        </button>
                        <div v-show="isVolumeOpen" class="library-player__volume-menu" @click.stop @mousedown.stop>
                            <vue-slider class="library-player__volume-slider" direction="btt"
                                :min="0" :max="100" :step="1"
                                height="7.5rem" width="1.8rem"
                                :dot-size="16"
                                :contained="true"
                                :drag-on-click="true"
                                tooltip="none"
                                :value="volume" @change="setVolume"
                                @dragging="setVolume"
                            ></vue-slider>
                        </div>
                    </div>
                    <!-- 收藏 --->
                    <button type="button" class="library-player__icon-button d-none d-sm-inline-block !hidden md:!flex" :class="track.favourite ? 'is-active' : ''" @click="addFavouriteTrack(track)" aria-label="收藏">
                        <svg-icon name="player-favourite" :class="['h-5', 'w-5', track.favourite ? 'fill-current' : '']" :viewBox="'0 0 24 24'" fill="none" stroke="currentColor"></svg-icon>

                    </button>
                    <!-- 循环播放 --->
                    <button type="button" class="library-player__icon-button !hidden md:!flex" :class="[repeat ? 'is-active' : '', syncReadonly ? 'is-disabled' : '']" :disabled="syncReadonly" @click="toggleRepeat" aria-label="循环播放">
                        <svg-icon name="player-repeat" :class="['h-5', 'w-5', repeat ? 'fill-current' : 'fill-current']"></svg-icon>

                    </button>
                    <!-- 随机播放 --->
                    <button type="button" class="library-player__icon-button !hidden md:!flex" :class="[shuffle ? 'is-active' : '', syncReadonly ? 'is-disabled' : '']" :disabled="syncReadonly" @click="toggleShuffle" aria-label="随机播放">
                        <svg-icon name="player-shuffle" :class="['h-5', 'w-5', shuffle ? 'fill-current' : 'fill-current']"></svg-icon>
                    </button>
                    <button type="button" class="library-player__icon-button !hidden md:!flex" @click="close" aria-label="折叠播放器">
                        <svg-icon name="player-close" class="icon fill-current"></svg-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- 小播放 --->
        <div class="w-full relative" v-if="track && !isOpen">
            <div :class="['library-mini-player', sidebarCollapsed ? 'is-sidebar-collapsed' : '']">
                <ProgressBar class="library-player__progress" />
                <div class="flex flex-col">
                    <!-- Track info --->
                    <div>
                        <div class="library-mini-player__content">
                            <button type="button" @click="handlePlayingDetails" class="library-mini-player__cover" aria-label="打开正在播放详情">
                                <img v-if="track.image" :src="track.image" class="library-player__cover-image">
                                <img v-else src="/static/dist/img/album_null.jpg" class="library-player__cover-image">
                            </button>
                            <div class="library-mini-player__meta">
                                <router-link :to="{ name: 'album', params: { id: track.albumId } }" class="library-player__title-link">
                                    <div class="library-player__title">
                                        {{ streamTitle || track.title }}
                                    </div>
                                </router-link>
                                <router-link :to="{ name: 'artist', params: { id: track.artistId } }" class="library-player__artist-link">
                                    <div class="library-player__artist">
                                        {{ track.artist || track.album }}
                                    </div>
                                </router-link>
                            </div>
                            <button type="button" class="library-mini-player__open library-player__icon-button" @click="open" aria-label="展开播放器">
                                <svg-icon name="player-next" class="icon fill-current"></svg-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 播放队列diolog --->
        <dialog id="play_queue" ref="play_queue" class="modal modal-bottom sm:modal-middle" @close="handleModalClose">
            <div class="modal-box h-5/6 !p-0">
                <h3 class="text-lg font-bold"></h3>
                <p class="">
                    <!-- 只在 modal 打开时才创建 DlnaQueue 组件，避免与路由页面的实例冲突 -->
                    <DlnaQueue v-if="isModalOpen"></DlnaQueue>
                </p>
            </div>
            <form method="dialog" class="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    </div>
</template>
<script>
    import ProgressBar from '@/views/library/player/ProgressBar'
    import DlnaQueue from '@/views/library/playing/dlnaQueue'
    import VueSlider from 'vue-slider-component'
    import {mapGetters} from 'vuex'
    import SvgIcon from '@/components/SvgIcon.vue';

    export default {
        components: {
            ProgressBar, VueSlider, SvgIcon, DlnaQueue
        },
        data() {
            return {
                isOpen: localStorage.getItem('isOpenBar') !== 'false',
                volumeDebounceTimer: null,
                isVolumeOpen: false,
                isModalOpen: false,  // 控制 modal 中的 DlnaQueue 组件是否创建
                sidebarCollapsed: localStorage.getItem('library_sidebar_collapsed') === '1'
            }
        },
        computed: {
            ...mapGetters(['track', 'trackId', 'shuffle', 'repeat']),
            visible() {
                // return this.$store.state.player.queue.length > 0
                return true
            },
            isPlaying: {
                get() {
                    return this.$store.state.common.isPlaying
                },
                set() {
                    if (this.syncReadonly) return
                    this.$store.dispatch('playPause')
                }
            },
            volume() {
                return Math.round(this.$store.state.common.volume * 100)
            },
            isMuted() {
                return this.$store.state.common.volume <= 0.0
            },
            repeatActive() {
                return this.$store.state.common.repeat
            },
            shuffleActive() {
                return this.$store.state.common.shuffle
            },
            isFavourite() {
                return ''
            },
            syncReadonly() {
                const syncRoom = this.$store.state.syncRoom
                if (!syncRoom || !syncRoom.isJoined) return false
                const currentUserId = syncRoom.currentUserId
                const ownerUserId = syncRoom.ownerUserId
                if (currentUserId === null || currentUserId === undefined || ownerUserId === null || ownerUserId === undefined) {
                    return true
                }
                return String(currentUserId) !== String(ownerUserId)
            },
            streamTitle() {
                return this.$store.state.streamTitle
            },
            documentTitle() {
                const trackTitle = this.track && this.track.title ? this.track.title : ''
                const trackArtist = this.track && this.track.artist ? this.track.artist : ''
                const trackAlbum = this.track && this.track.album ? this.track.album : ''
                return [
                    this.streamTitle || trackTitle,
                    trackArtist || trackAlbum,
                    'Music Tag Web'
                ].filter(x => !!x).join(' • ')
            }
        },
        watch: {
            documentTitle: {
                immediate: true,
                handler(value) {
                    document.title = value
                }
            },
        },
        mounted() {
            window.addEventListener('library-sidebar-collapsed-changed', this.handleSidebarCollapsedChange)
            window.addEventListener('storage', this.handleStorageChange)
            document.addEventListener('click', this.handleDocumentClick)
        },
        destroyed() {
            document.title = 'Music Tag Web'
        },
        beforeDestroy() {
            // 清理音量防抖定时器
            if (this.volumeDebounceTimer) {
                clearTimeout(this.volumeDebounceTimer)
                this.volumeDebounceTimer = null
            }
            window.removeEventListener('library-sidebar-collapsed-changed', this.handleSidebarCollapsedChange)
            window.removeEventListener('storage', this.handleStorageChange)
            document.removeEventListener('click', this.handleDocumentClick)
        },
        methods: {
            toggleVolumeMenu() {
                this.isVolumeOpen = !this.isVolumeOpen
            },
            closeVolumeMenu() {
                this.isVolumeOpen = false
            },
            handleDocumentClick(event) {
                const dropdown = this.$refs.volumeDropdown
                if (dropdown && dropdown.contains(event.target)) return
                this.closeVolumeMenu()
            },
            handleSidebarCollapsedChange(event) {
                this.sidebarCollapsed = !!(event.detail && event.detail.collapsed)
            },
            handleStorageChange(event) {
                if (event.key === 'library_sidebar_collapsed') {
                    this.sidebarCollapsed = event.newValue === '1'
                }
            },
            playPause() {
                if (this.syncReadonly) return false
                return this.$store.dispatch('playPause')
            },
            next() {
                if (this.syncReadonly) return false
                return this.$store.dispatch('next')
            },
            previous() {
                if (this.syncReadonly) return false
                return this.$store.dispatch('previous')
            },
            setVolume(volume) {
                if (this.volumeDebounceTimer) {
                    clearTimeout(this.volumeDebounceTimer)
                    this.volumeDebounceTimer = null
                }
                this.$store.dispatch('setVolume', parseFloat(volume / 100))
            },
            toggleRepeat() {
                if (this.syncReadonly) return false
                return this.$store.dispatch('toggleRepeat')
            },
            toggleShuffle() {
                if (this.syncReadonly) return false
                return this.$store.dispatch('toggleShuffle')
            },
            close() {
                localStorage.setItem('isOpenBar', 'false')
                this.isOpen = false
            },
            open() {
                localStorage.setItem('isOpenBar', 'true')
                this.isOpen = true
            },
            handlePlayingDetails() {
                console.log('handlePlayingDetails', this.$route.name)
                if (this.$route.name === 'playingList') {
                    this.$router.go(-1)
                } else {
                    this.$router.push({name: 'playingList', params: {id: this.track.id}})
                }
            },
            addFavouriteTrack(item) {
                if (item.favourite) {
                    this.$api.subsonic.removeFavourite(item.id, 'track').then((res) => {
                        item.favourite = false
                    })
                } else {
                    this.$api.subsonic.addFavourite(item.id, 'track').then((res) => {
                        item.favourite = true
                    })
                }
            },
            openModal() {
                this.isModalOpen = true
                this.$nextTick(() => {
                    this.$refs.play_queue.showModal()
                })
            },
            handleModalClose() {
                // modal 关闭时，销毁 DlnaQueue 组件以释放资源
                this.isModalOpen = false
            }
        }
    }
</script>
<style scoped>
.player {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0;
    max-height: 0;
    transition: max-height 0.5s;
}

.visible {
    height: auto;
    max-height: 100px;
}

.icon {
    display: flex;
    align-items: center;
}

.library-player {
    position: relative;
    isolation: isolate;
    overflow: visible;
    width: 100%;
    border-radius: 0.75rem;
    color: oklch(var(--bc));
    background:
        linear-gradient(135deg, color-mix(in oklch, oklch(var(--b1)) 72%, transparent), color-mix(in oklch, oklch(var(--b2)) 58%, transparent)),
        color-mix(in oklch, oklch(var(--b1)) 66%, transparent);
    border: 1px solid color-mix(in oklch, oklch(var(--bc)) 14%, transparent);
    box-shadow:
        inset 0 1px 0 color-mix(in oklch, oklch(var(--b1)) 72%, transparent),
        0 18px 48px color-mix(in oklch, oklch(var(--bc)) 14%, transparent);
    backdrop-filter: blur(22px) saturate(160%);
    -webkit-backdrop-filter: blur(22px) saturate(160%);
}

.library-player::before,
.library-mini-player::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    border-radius: inherit;
    background:
        radial-gradient(circle at 16% 0%, color-mix(in oklch, oklch(var(--p)) 18%, transparent), transparent 34%),
        linear-gradient(90deg, color-mix(in oklch, oklch(var(--b1)) 34%, transparent), transparent 48%, color-mix(in oklch, oklch(var(--bc)) 6%, transparent));
}

.library-player__progress {
    display: block;
    margin: -6px 0 -5px;
}

.library-player__grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    min-height: 4.5rem;
    gap: 0.5rem;
    padding: 0 0.55rem;
}

.library-player__track,
.library-player__actions {
    min-width: 0;
}

.library-player__track-inner {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 0.62rem;
}

.library-player__cover,
.library-mini-player__cover {
    position: relative;
    flex: 0 0 auto;
    width: 3.5rem;
    height: 3.5rem;
    overflow: hidden;
    padding: 0;
    border: 1px solid color-mix(in oklch, oklch(var(--bc)) 12%, transparent);
    border-radius: 0.75rem;
    background: color-mix(in oklch, oklch(var(--b2)) 72%, transparent);
    box-shadow: inset 0 1px 0 color-mix(in oklch, oklch(var(--b1)) 58%, transparent);
    transition: transform 0.16s ease, filter 0.16s ease, border-color 0.16s ease;
}

.library-player__cover:hover,
.library-mini-player__cover:hover {
    filter: brightness(0.88);
    border-color: color-mix(in oklch, oklch(var(--p)) 38%, transparent);
}

.library-player__cover:active,
.library-mini-player__cover:active,
.library-player__icon-button:active,
.library-player__play-toggle:active {
    transform: translateY(1px) scale(0.98);
}

.library-player__cover-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.library-player__meta,
.library-mini-player__meta {
    min-width: 0;
    flex: 1 1 auto;
}

.library-player__title-link,
.library-player__artist-link {
    display: block;
    min-width: 0;
    color: inherit;
    text-decoration: none;
}

.library-player__title-link:hover,
.library-player__artist-link:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
}

.library-player__title,
.library-player__artist {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.library-player__title {
    color: oklch(var(--bc));
    font-size: 0.9rem;
    font-weight: 650;
    line-height: 1.25;
}

.library-player__artist {
    margin-top: 0.2rem;
    color: color-mix(in oklch, oklch(var(--bc)) 58%, transparent);
    font-size: 0.76rem;
    line-height: 1.2;
}

.library-player__controls {
    display: grid;
    grid-template-columns: 2.35rem 2.9rem 2.35rem;
    align-items: center;
    justify-items: center;
    justify-content: center;
    gap: 0.32rem;
}

.library-player__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
}

.library-player__icon-button,
.library-player__play-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 0;
    line-height: 1;
    appearance: none;
    border: 1px solid color-mix(in oklch, oklch(var(--bc)) 5%, transparent);
    border-radius: 9999px;
    background: color-mix(in oklch, oklch(var(--b1)) 42%, transparent);
    color: color-mix(in oklch, oklch(var(--bc)) 78%, transparent);
    cursor: pointer;
    transition: transform 0.16s ease, background 0.16s ease, color 0.16s ease, border-color 0.16s ease;
}

.library-player__icon-button {
    width: 2.25rem;
    height: 2.25rem;
}

.library-player__icon-button svg,
.library-player__icon-button .icon {
    width: 1.16rem;
    height: 1.16rem;
}

.library-player__play-toggle {
    position: relative;
    --library-player-play-size: 2.9rem;
    width: var(--library-player-play-size);
    height: var(--library-player-play-size);
    background: transparent;
    color: oklch(var(--p));
    border-color: transparent;
    box-shadow: none;
}

.library-player__play-toggle svg {
    width: var(--library-player-play-size);
    height: var(--library-player-play-size);
    display: block;
}

.library-player__icon-button:hover,
.library-player__icon-button.is-active {
    background: color-mix(in oklch, oklch(var(--p)) 12%, oklch(var(--b1)) 74%);
    color: oklch(var(--bc));
    border-color: color-mix(in oklch, oklch(var(--p)) 18%, transparent);
}

.library-player__play-toggle:hover {
    background: transparent;
    color: color-mix(in oklch, oklch(var(--p)) 88%, oklch(var(--bc)) 12%);
}

.library-player__icon-button.is-active {
    color: oklch(var(--p));
}

.library-player__icon-button.is-disabled,
.library-player__play-toggle.is-disabled {
    opacity: 0.42;
    cursor: not-allowed;
    pointer-events: none;
}

.library-player__dropdown {
    position: relative;
    align-items: center;
}

.library-player__dropdown .library-player__volume-menu {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    bottom: calc(100% + 0.5rem);
    z-index: 30;
    min-width: 3.2rem;
    padding: 0.72rem 0.55rem;
    border-radius: 0.75rem;
    border: 1px solid color-mix(in oklch, oklch(var(--bc)) 12%, transparent);
    background: color-mix(in oklch, oklch(var(--b1)) 82%, transparent);
    box-shadow:
        inset 0 1px 0 color-mix(in oklch, oklch(var(--b1)) 70%, transparent),
        0 16px 36px color-mix(in oklch, oklch(var(--bc)) 18%, transparent);
    backdrop-filter: blur(18px) saturate(150%);
    -webkit-backdrop-filter: blur(18px) saturate(150%);
    pointer-events: auto;
    transform: translateX(-50%);
}

.library-player__volume-slider {
    width: 1.65rem !important;
    height: 7.5rem;
    padding: 0.35rem 0.45rem;
    cursor: pointer;
}

:deep(.library-player__volume-slider .vue-slider-rail) {
    background-color: color-mix(in oklch, oklch(var(--bc)) 12%, transparent) !important;
    width: 0.32rem !important;
    margin: 0 auto;
}

:deep(.library-player__volume-slider .vue-slider-process) {
    background-color: oklch(var(--p)) !important;
    width: 100% !important;
}

:deep(.library-player__volume-slider .vue-slider-dot) {
    cursor: grab;
}

:deep(.library-player__volume-slider .vue-slider-dot:active) {
    cursor: grabbing;
}

:deep(.library-player__volume-slider .vue-slider-dot-handle) {
    border-color: oklch(var(--p));
    background-color: oklch(var(--b1));
    box-shadow: 0 0 0 3px color-mix(in oklch, oklch(var(--p)) 16%, transparent);
}

/deep/ .library-player__volume-slider .vue-slider-rail {
    background-color: color-mix(in oklch, oklch(var(--bc)) 12%, transparent) !important;
    width: 0.32rem !important;
    margin: 0 auto;
}

/deep/ .library-player__volume-slider .vue-slider-process {
    background-color: oklch(var(--p)) !important;
    width: 100% !important;
}

/deep/ .library-player__volume-slider .vue-slider-dot-handle {
    border-color: oklch(var(--p));
    background-color: oklch(var(--b1));
    box-shadow: 0 0 0 3px color-mix(in oklch, oklch(var(--p)) 16%, transparent);
}

.library-mini-player {
    position: absolute;
    isolation: isolate;
    left: calc(-50% + 0.5rem);
    bottom: -1rem;
    width: 14rem;
    overflow: hidden;
    border-radius: 0.75rem;
    color: oklch(var(--bc));
    background:
        linear-gradient(135deg, color-mix(in oklch, oklch(var(--b1)) 72%, transparent), color-mix(in oklch, oklch(var(--b2)) 58%, transparent)),
        color-mix(in oklch, oklch(var(--b1)) 66%, transparent);
    border: 1px solid color-mix(in oklch, oklch(var(--bc)) 14%, transparent);
    box-shadow:
        inset 0 1px 0 color-mix(in oklch, oklch(var(--b1)) 72%, transparent),
        0 18px 42px color-mix(in oklch, oklch(var(--bc)) 16%, transparent);
    backdrop-filter: blur(22px) saturate(160%);
    -webkit-backdrop-filter: blur(22px) saturate(160%);
    transition: width 0.2s ease, left 0.2s ease, background 0.2s ease;
}

.library-mini-player__content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 4.5rem;
    gap: 0.62rem;
    padding: 0 0.48rem;
}

.library-mini-player.is-sidebar-collapsed {
    width: 4.5rem;
}

.library-mini-player.is-sidebar-collapsed .library-mini-player__content {
    position: relative;
}

.library-mini-player.is-sidebar-collapsed .library-mini-player__cover {
    width: 3.5rem;
    height: 3.5rem;
    margin: 0.5rem auto;
}

.library-mini-player.is-sidebar-collapsed .library-mini-player__meta {
    display: none;
}

.library-mini-player.is-sidebar-collapsed .library-mini-player__open {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0;
    background: color-mix(in oklch, oklch(var(--b1)) 68%, transparent);
}

.library-mini-player.is-sidebar-collapsed .library-mini-player__open svg {
    width: 1rem;
    height: 1rem;
}

.library-mini-player__open {
    margin-left: auto;
}

/deep/ .vue-slider-process {
    background-color: oklch(var(--p)/1) !important;
}
:deep(.vue-slider-dot-tooltip-inner) {
    background-color: oklch(var(--p)/1);
    border-color: oklch(var(--p)/1);
}

@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    .library-player,
    .library-mini-player,
    .library-player__volume-menu {
        background: color-mix(in oklch, oklch(var(--b1)) 94%, oklch(var(--b2)));
    }
}

@media (prefers-reduced-transparency: reduce) {
    .library-player,
    .library-mini-player,
    .library-player__volume-menu {
        background: color-mix(in oklch, oklch(var(--b1)) 96%, oklch(var(--b2)));
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
    }
}

@media (max-width: 767px) {
    .library-player__grid {
        grid-template-columns: minmax(0, 1fr) auto auto;
        min-height: 4.5rem;
        gap: 0.35rem;
        padding: 0 0.45rem;
    }

    .library-player__cover {
        width: 3.25rem;
        height: 3.25rem;
    }

    .library-player__title {
        font-size: 0.84rem;
    }

    .library-player__artist {
        font-size: 0.72rem;
    }

    .library-player__controls {
        grid-template-columns: 2.1rem 2.65rem 2.1rem;
        gap: 0.18rem;
    }

    .library-player__icon-button {
        width: 2rem;
        height: 2rem;
    }

    .library-player__play-toggle {
        --library-player-play-size: 2.55rem;
    }

    .library-player__play-toggle svg {
        width: var(--library-player-play-size);
        height: var(--library-player-play-size);
    }

    .library-player__actions {
        gap: 0;
    }
}
</style>
